import React, {Component} from 'react';
import {Timeline, Icon, Alert, Spin} from 'antd';
import {timeConverter} from '../utils'

class StationCardEvent extends Component {
  render() {
    const {scripts, events, receiving} = this.props
    const scriptMap = scripts.reduce(function(map, sc) {
      map[sc.ScriptId] = sc
      return map;
    }, {});

    const elReceiving = receiving
      ? <span className="center"><Spin/></span>
      : null
    return <div>
      {
        (scripts.length === 0 || events.length === 0)
          ? <Alert message="Không có dữ liệu!" type="info"/>
          : <div>
              {elReceiving}
              <Timeline>
                {
                  events.map((ev, i) => {
                    const event = scriptMap[ev.EventID]
                    const eventName = event && event.Name || ''
                    const t = ev.StartTime || ev.Time
                    const color = ev.AlarmLevel === 0
                      ? 'green'
                      : 'orange'
                    return <Timeline.Item key={i + 1} dot={<Icon type = "clock-circle-o" style = {{ fontSize: 16, color: color }}/>}>
                      <span className="time">{timeConverter(t)}</span>
                      <span className="name">{eventName}</span>
                    </Timeline.Item>
                  })
                }
              </Timeline>
            </div>
      }
    </div>;
  }
}

export default StationCardEvent;
/*
<Timeline.Item>Create a services site 2015-09-01</Timeline.Item>
<Timeline.Item>Solve initial network problems 2015-09-01</Timeline.Item>
<Timeline.Item dot={<Icon type = "clock-circle-o" style = {{ fontSize: '16px' }}/>} color="red">Technical testing 2015-09-01</Timeline.Item>
<Timeline.Item>Network problems being solved 2015-09-01</Timeline.Item>
<Timeline.Item color="green">Create a services site 2015-09-01</Timeline.Item>
<Timeline.Item color="green">Create a services site 2015-09-01</Timeline.Item>
<Timeline.Item color="red">
  <p>Solve initial network problems 1</p>
  <p>Solve initial network problems 2</p>
  <p>Solve initial network problems 3 2015-09-01</p>
</Timeline.Item>
<Timeline.Item>
  <p>Technical testing 1</p>
  <p>Technical testing 2</p>
  <p>Technical testing 3 2015-09-01</p>
</Timeline.Item>

*/

/*
render() {
  const {scripts, events, receiving} = this.props
  const scriptMap = scripts.reduce(function(map, sc) {
    map[sc.ScriptId] = sc
    return map;
  }, {});
  const elReceiving = receiving
    ? <span className="center"><Spin/></span>
    : null
  return <div>
    {
      (scripts.length === 0 || events.length === 0)
        ? <Alert message="Không có dữ liệu" type="info"/>
        : <div>
            {elReceiving}
            <Timeline>
              {
                events.filter((ev) => {
                  const event = scriptMap[ev.EventID]
                  return (event)
                }).map((ev, i) => {
                  const event = scriptMap[ev.EventID]
                  const eventName = event.Name || ''
                  const t = ev.StartTime || ev.Time
                  const color = ev.AlarmLevel === 0
                    ? 'green'
                    : 'orange'
                  return <Timeline.Item key={i + 1} dot={<Icon type = "clock-circle-o" style = {{ fontSize: 16, color: color }}/>}>
                    <span className="time">{timeConverter(t)}</span>
                    <span className="name">{eventName}</span>
                  </Timeline.Item>
                })
              }
            </Timeline>
          </div>
    }
  </div>;
}
*/



// WEBPACK FOOTER //
// ./src/components/StationCardEvent.js